import { SVGProps } from 'react'
import { cn } from '../../utils'

export enum MediaType {
  Facebook = 'facebook',
  Linkedin = 'linkedin',
  Reddit = 'reddit',
  X = 'x',
}

export const MediaSharePath = {
  [MediaType.Facebook]: 'https://www.facebook.com/sharer/sharer.php?u=$url',
  [MediaType.Linkedin]: 'https://www.linkedin.com/shareArticle?mini=true&url=$url',
  [MediaType.Reddit]: 'https://www.reddit.com/submit?url=$url&title=$title',
  [MediaType.X]: 'https://twitter.com/intent/tweet?url=$url&text=$title',
}

export const generateSharePath = (type: MediaType, url: string, title: string) => {
  return MediaSharePath[type].replace('$url', encodeURIComponent(url)).replace('$title', encodeURIComponent(title))
}

export function FacebookShareIcon({ className, ...r }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('hover:text-primary-hover hover:fill-primary-hover group cursor-pointer', className)}
      {...r}
    >
      <circle cx="20" cy="20" r="19.5" stroke="currentColor" />
      <path
        d="M21.7302 21.8839H24.1338L25.0952 18.0982H21.7302V16.2054C21.7302 15.2305 21.7302 14.3125 23.6531 14.3125H25.0952V11.1325C24.7818 11.0918 23.5983 11 22.3484 11C19.738 11 17.8844 12.5682 17.8844 15.4482V18.0982H15V21.8839H17.8844V29.9286H21.7302V21.8839Z"
        className="light-theme:fill-black group-hover:fill-white"
        fill="white"
      />
    </svg>
  )
}

export function LinkedinShareIcon({ className, ...r }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('hover:text-primary-hover hover:fill-primary-hover group cursor-pointer', className)}
      {...r}
    >
      <circle cx="20" cy="20" r="19.5" stroke="currentColor" />
      <path
        d="M15.6183 16.1814V29.0236H11.3419V16.1814H15.6183ZM15.8905 12.216C15.8991 12.8466 15.681 13.3736 15.2361 13.7969C14.7911 14.2203 14.2058 14.4319 13.4801 14.4319H13.4542C12.7458 14.4319 12.1756 14.2203 11.7436 13.7969C11.3117 13.3736 11.0957 12.8466 11.0957 12.216C11.0957 11.5767 11.3182 11.0475 11.7631 10.6285C12.208 10.2095 12.789 10 13.506 10C14.2231 10 14.7976 10.2095 15.2296 10.6285C15.6615 11.0475 15.8818 11.5767 15.8905 12.216ZM31.0005 21.663V29.0236H26.737V22.1554C26.737 21.2483 26.5621 20.5377 26.2122 20.0237C25.8623 19.5096 25.3159 19.2526 24.5729 19.2526C24.0286 19.2526 23.5729 19.4016 23.2057 19.6997C22.8386 19.9978 22.5643 20.3671 22.3829 20.8077C22.2878 21.0669 22.2403 21.4167 22.2403 21.8573V29.0236H17.9769C17.9941 25.5765 18.0028 22.7817 18.0028 20.6392C18.0028 18.4967 17.9984 17.2181 17.9898 16.8034L17.9769 16.1814H22.2403V18.0474H22.2144C22.3872 17.771 22.5643 17.5291 22.7457 17.3217C22.9271 17.1144 23.1712 16.8898 23.4779 16.6479C23.7846 16.406 24.1604 16.2181 24.6053 16.0842C25.0502 15.9503 25.5448 15.8833 26.0891 15.8833C27.5664 15.8833 28.7543 16.3736 29.6528 17.3541C30.5512 18.3347 31.0005 19.771 31.0005 21.663Z"
        fill="white"
        className="light-theme:fill-black group-hover:fill-white"
      />
    </svg>
  )
}
export function InstagramIcon({ className, ...r }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      className={cn('hover:text-primary-hover hover:fill-primary-hover group cursor-pointer', className)}
      {...r}
    >
      <circle cx="20" cy="20" r="19.5" stroke="currentColor" />
      <path
        d="M11 16.0378C11 13.2554 13.2572 11 16.0378 11H23.9622C26.7446 11 29 13.2572 29 16.0378V23.9622C29 26.7446 26.7428 29 23.9622 29H16.0378C13.2554 29 11 26.7428 11 23.9622V16.0378ZM25.22 16.04C25.5542 16.04 25.8747 15.9072 26.111 15.671C26.3472 15.4347 26.48 15.1142 26.48 14.78C26.48 14.4458 26.3472 14.1253 26.111 13.889C25.8747 13.6527 25.5542 13.52 25.22 13.52C24.8858 13.52 24.5653 13.6527 24.329 13.889C24.0927 14.1253 23.96 14.4458 23.96 14.78C23.96 15.1142 24.0927 15.4347 24.329 15.671C24.5653 15.9072 24.8858 16.04 25.22 16.04ZM23.24 20C23.24 20.4255 23.1562 20.8468 22.9934 21.2399C22.8305 21.633 22.5919 21.9902 22.291 22.291C21.9902 22.5919 21.633 22.8305 21.2399 22.9934C20.8468 23.1562 20.4255 23.24 20 23.24C19.5745 23.24 19.1532 23.1562 18.7601 22.9934C18.367 22.8305 18.0098 22.5919 17.709 22.291C17.4081 21.9902 17.1695 21.633 17.0066 21.2399C16.8438 20.8468 16.76 20.4255 16.76 20C16.76 19.1407 17.1014 18.3166 17.709 17.709C18.3166 17.1014 19.1407 16.76 20 16.76C20.8593 16.76 21.6834 17.1014 22.291 17.709C22.8986 18.3166 23.24 19.1407 23.24 20ZM15.32 20C15.32 22.5848 17.4152 24.68 20 24.68C22.5848 24.68 24.68 22.5848 24.68 20C24.68 17.4152 22.5848 15.32 20 15.32C17.4152 15.32 15.32 17.4152 15.32 20Z"
        fill="white"
        className="light-theme:fill-black group-hover:fill-white"
      />
    </svg>
  )
}

export function RedditShareIcon({ className }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('hover:text-primary-hover hover:fill-primary-hover group cursor-pointer', className)}
    >
      <circle cx="20" cy="20" r="19.5" stroke="currentColor" />
      <path
        d="M22.2213 23.0244C22.3404 23.1435 22.3404 23.259 22.2213 23.3706C21.76 23.8319 21.0196 24.0625 20 24.0625C18.9804 24.0625 18.24 23.8319 17.7788 23.3706C17.6596 23.259 17.6596 23.1435 17.7788 23.0244C17.8233 22.9798 17.8792 22.9575 17.9463 22.9575C18.0133 22.9575 18.0692 22.9798 18.1138 23.0244C18.4708 23.389 19.0996 23.5712 20 23.5712C20.8929 23.5712 21.5217 23.389 21.8863 23.0244C21.9308 22.9798 21.9867 22.9575 22.0538 22.9575C22.1208 22.9575 22.1767 22.9798 22.2213 23.0244ZM18.7944 21.0044C18.7944 21.2798 18.6977 21.5142 18.5044 21.7075C18.311 21.9008 18.0767 21.9975 17.8013 21.9975C17.5258 21.9975 17.2896 21.9008 17.0925 21.7075C16.8954 21.5142 16.7969 21.2798 16.7969 21.0044C16.7969 20.7215 16.8954 20.4833 17.0925 20.29C17.2896 20.0967 17.5258 20 17.8013 20C18.0767 20 18.311 20.0985 18.5044 20.2956C18.6977 20.4927 18.7944 20.729 18.7944 21.0044ZM23.2031 21.0044C23.2031 21.2798 23.1046 21.5142 22.9075 21.7075C22.7104 21.9008 22.4742 21.9975 22.1988 21.9975C21.9233 21.9975 21.689 21.9008 21.4956 21.7075C21.3023 21.5142 21.2056 21.2798 21.2056 21.0044C21.2056 20.729 21.3023 20.4927 21.4956 20.2956C21.689 20.0985 21.9233 20 22.1988 20C22.4742 20 22.7104 20.0967 22.9075 20.29C23.1046 20.4833 23.2031 20.7215 23.2031 21.0044ZM26.0044 19.665C26.0044 19.3004 25.8742 18.9879 25.6138 18.7275C25.3533 18.4671 25.0371 18.3369 24.665 18.3369C24.2929 18.3369 23.9729 18.4708 23.705 18.7387C22.7379 18.0692 21.5808 17.7121 20.2338 17.6675L20.9369 14.5087L23.1687 15.0113C23.1687 15.2867 23.2654 15.521 23.4588 15.7144C23.6521 15.9077 23.8865 16.0044 24.1619 16.0044C24.4373 16.0044 24.6735 15.9058 24.8706 15.7087C25.0677 15.5117 25.1663 15.2754 25.1663 15C25.1663 14.7246 25.0677 14.4883 24.8706 14.2912C24.6735 14.0942 24.4373 13.9956 24.1619 13.9956C23.7602 13.9956 23.4625 14.1817 23.2688 14.5538L20.8025 14.0069C20.6613 13.9698 20.5683 14.0294 20.5238 14.1856L19.7538 17.6675C18.4146 17.7196 17.265 18.0804 16.305 18.75C16.0446 18.4746 15.7208 18.3369 15.3338 18.3369C14.9617 18.3369 14.6454 18.4671 14.385 18.7275C14.1246 18.9879 13.9944 19.3004 13.9944 19.665C13.9944 19.9254 14.0631 20.1635 14.2006 20.3794C14.3381 20.5952 14.5223 20.759 14.7531 20.8706C14.7085 21.0715 14.6863 21.2798 14.6863 21.4956C14.6863 22.5523 15.2071 23.4562 16.2488 24.2075C17.2904 24.9587 18.5442 25.3346 20.01 25.335C21.4833 25.335 22.7408 24.9592 23.7825 24.2075C24.8242 23.4558 25.345 22.5519 25.345 21.4956C25.345 21.2577 25.319 21.0456 25.2669 20.8594C25.4902 20.7477 25.6688 20.5858 25.8025 20.3738C25.9363 20.1617 26.0031 19.9254 26.0031 19.665H26.0044ZM30 20C30 21.3542 29.7358 22.6487 29.2075 23.8837C28.6792 25.1187 27.9685 26.1827 27.0756 27.0756C26.1827 27.9685 25.1188 28.6792 23.8838 29.2075C22.6488 29.7358 21.3542 30 20 30C18.6458 30 17.3513 29.7358 16.1163 29.2075C14.8813 28.6792 13.8173 27.9685 12.9244 27.0756C12.0315 26.1827 11.3208 25.1187 10.7925 23.8837C10.2642 22.6487 10 21.3542 10 20C10 18.6458 10.2642 17.3513 10.7925 16.1163C11.3208 14.8813 12.0315 13.8173 12.9244 12.9244C13.8173 12.0315 14.8813 11.3208 16.1163 10.7925C17.3513 10.2642 18.6458 10 20 10C21.3542 10 22.6488 10.2642 23.8838 10.7925C25.1188 11.3208 26.1827 12.0315 27.0756 12.9244C27.9685 13.8173 28.6792 14.8813 29.2075 16.1163C29.7358 17.3513 30 18.6458 30 20Z"
        fill="white"
        className="light-theme:fill-black group-hover:fill-white"
      />
    </svg>
  )
}

export function XShareIcon({ className }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('hover:text-primary-hover hover:fill-primary-hover group cursor-pointer', className)}
    >
      <circle cx="20" cy="20" r="19.5" stroke="currentColor" />
      <path
        d="M25.7512 12H28.818L22.1179 19.6246L30 30H23.8284L18.9946 23.7074L13.4636 30H10.3949L17.5613 21.8446L10 12H16.3283L20.6976 17.7517L25.7512 12ZM24.6748 28.1723H26.3742L15.4049 13.7317H13.5813L24.6748 28.1723Z"
        fill="white"
        className="light-theme:fill-black group-hover:fill-white"
      />
    </svg>
  )
}
